import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TextButtonMedium = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Medium Text button"}
        value={"<Button variant={'text'}>Medium</Button>"}
      >
        <Button variant={"text"}>Medium</Button>
      </PreviewAndEditor>
    </>
  );
};

export default TextButtonMedium;
